import * as React from "react";
const SvgImplements = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { height: "1em", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 6, r: 5.4, stroke: "currentColor", strokeWidth: 1.2, strokeDasharray: "4.241025 4.241025", transform: "rotate(22.5 6 6)" }), /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 6, r: 1, fill: "currentColor" }));
export {
  SvgImplements as default
};
//# sourceMappingURL=implements.js.map
